import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { MatSelect } from '@angular/material/select';
import { CurrencyPipe } from '@angular/common';
import { ARService } from '../../ar.service';
import { ArPaymentComponent } from '../../payment/ar-payment/ar-payment.component';
import { ArInsuranceClaimsComponent } from '../ar-insurance-claims/ar-insurance-claims.component';
import { Globals } from '../../../../globals';
import { ArPaymentInvoiceGeneratorComponent } from '../../payment/ar-payment-invoice-generator/ar-payment-invoice-generator.component';
import { ArDiscountComponent } from '../ar-discount/ar-discount.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ContextButton, ContextEvent } from '../../../tdo-shared/general-context/general-context.component';
import { ConfirmActionButton, GeneralConfirmComponent } from '../../../tdo-shared/general-confirm/general-confirm.component';
import { PlanListComponent } from '../../payment-plan/plan-list/plan-list.component';
import { PlanViewComponent } from '../../payment-plan/plan-view/plan-view.component';
import { PatientDataModel } from '../../../../models/patient/patient-data.model';
import { ContactDataModel } from '../../../../models/person/contact-data.model';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { DataARPaymentPlanModel } from '../../../../models/accountsReceivable/data-ar-payment-plan.model';
import { DataARLedgerListModel, isPayableLedgerItem } from '../../models/data-ar-ledger-list.model';
import { SalutationEnum } from '../../../../models/enum/salutation.enum';
import { DoctorByTDOCIDModel } from '../../models/doctor-by-tdocid.model';
import { UntypedFormControl, FormGroup, FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { SelectTDOCIDLOCIDModel } from '../../models/select-tdocid-locid.model';
import { UiService } from '../../../../services/ui.service';
import { ClaimTypeEnum } from '../../../../models/enum/claim-type.enum';
import { ClaimWizardComponent } from '../../claims/claim-wizard/claim-wizard.component';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { MessagingService } from '../../../../services/messaging.service';
import { NoteCategoryEnum } from '../../../../models/enum/note-category.enum';
import { TdoNoteAssociatedObject, TdoNoteSaveModel } from '../../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { firstValueFrom, fromEvent, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { TdoNoteQueryModel } from '../../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import { NotesService } from '../../../../services/notes.service';
import { AuthenticationService } from '../../../auth/services/authentication.service';
import { UserRoleEnum } from '../../../../models/enum/user-role.enum';
import { ArPaymentRefundConfirmComponent } from '../../payment/ar-payment-refund-confirm/ar-payment-refund-confirm.component';
import { ArPaymentRefundAnyAmountConfirmComponent } from '../../payment/ar-payment-refund-any-amount-confirm/ar-payment-refund-any-amount-confirm.component';
import { DialogService } from '../../../../services/dialog.service';
import { NoteTypeEnum } from '../../../../models/enum/note-type.enum';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { ConversionUtilities } from '../../../../utilities/conversion.utilities';
import { ClaimViewComponent } from '../../claims/claim-view/claim-view.component';
import { ArLedgerPaymentDistributionsComponent } from '../ar-ledger-payment-distributions/ar-ledger-payment-distributions.component';
import { CreateAdjustment2Component } from '../create-adjustment2/create-adjustment2.component';
import { ArLedgerProcedureDetailsComponent } from '../ar-ledger-procedure-details/ar-ledger-procedure-details.component';
import { ARLedgerTableColumn } from '../../models/ar-ledger-table.model';
import { ArLedgerTableLayoutManagerComponent } from '../ar-ledger-table-layout-manager/ar-ledger-table-layout-manager.component';
import { DataArLedgerCredits } from '../../models/data-ar-ledger-credits';
import { ArPaymentDetailsComponent } from '../../payment/ar-payment-details/ar-payment-details.component';
import { ClaimStatusEnum } from '../../../../models/enum/claim-status.enum';
import { ArPaymentCancelComponent } from '../../payment/ar-payment-cancel/ar-payment-cancel.component';
import { TdoUserParameters } from '../../../../models/configuration/user/tdo-user-parameters';
import { ArInsurancePaymentComponent } from '../../payment/ar-insurance-payment/ar-insurance-payment.component';
import { PrintLedgerParamsModel } from 'src/app/models/accountsReceivable/print-ledgerParams.model';
import { ReportIDEnum } from 'src/app/models/enum/report-ID-enum';
import { TDOPrintService } from 'src/app/services/print/tdoprint.service';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';
import { NoteDataModel } from '../../../../models/notes/note-data.model';
import { ArPaymentDistributionsComponent } from '../../payment/ar-payment-distributions/ar-payment-distributions.component';
import { ArLedgerChargeVoidComponent } from '../ar-ledger-void/ar-ledger-charge-void.component';
import { EnumARPaymentType } from 'src/app/models/enum/enum-ar-payment-type';
import { InterestAndLateFeesComponent } from '../interest-and-late-fees/interest-and-late-fees.component';
import { FileManagerService } from 'src/app/modules/file-manager/file-manager.service';
import { TdoOrganizerSlideshowDialogComponent } from 'src/app/main-interface/organizer/dialogs/tdo-organizer-slideshow-dialog/tdo-organizer-slideshow-dialog.component';

@Component({
  standalone: false,
  selector: 'app-ar-ledger',
  templateUrl: './ar-ledger.component.html',
  styleUrls: ['./ar-ledger.component.scss']
})
export class ArLedgerComponent implements OnInit, AfterViewInit, OnDestroy {
  //@ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
  @ViewChild('ledgerItemContextMenu') ledgerItemContextTemplate: TemplateRef<any>;
  @ViewChild('eobDocumentMenu', { read: MatMenuTrigger }) eobDocumentMenuTrigger: MatMenuTrigger;
  @ViewChild('dateRangeStart') dateRangeStart: ElementRef<HTMLInputElement>;
  @ViewChild('dateRangeEnd') dateRangeEnd: ElementRef<HTMLInputElement>;
  @ViewChild('dateRangeInput') dateRangeInput: any;
  @ViewChild('picker') picker: MatDateRangePicker<Date>;
  @ViewChild('doctorSelect') doctorSelect: MatSelect;
  @ViewChild('locationSelect') locationSelect: MatSelect;
  @ViewChild('toothSelect') toothSelect: MatSelect;
  @ViewChild('codeSelect') codeSelect: MatSelect;

  TDOUserID: string;
  LOCID: number;
  CaseWorkItemId: string = '';
  PatientId: string = '';
  PatientCaseId: string = '';
  DoctorId: string = '';

  showContext: boolean = false;
  contextPositionX: number = 0;
  contextPositionY: number = 0;
  contextMenuButtons: ContextButton[] = [];
  
  // EOB document context menu
  selectedEOBLedgerItem: DataARLedgerListModel = null;
  eobMenuPositionX: string = '0px';
  eobMenuPositionY: string = '0px';

  hidePaymentPlanItems: boolean = false;
  hidePaymentItems: boolean = false;
  hidePaidLedgerItems: boolean = false;
  hideOutstandingBalance: boolean = false;
  hideVoidedLedgerItems: boolean = false;
  isLoading: boolean = false;
  dataPatient: PatientDataModel;
  dataContact: ContactDataModel;

  isCollections: boolean = false;
  isPaymentPlan: boolean = false;
  isInterest: boolean = true;

  bkDataLedgerItems: DataARLedgerListModel[] = [];
  dataLedgerItems: DataARLedgerListModel[] = [];
  dataLedgerItemsTable: DataARLedgerListModel[] = [];
  paymentPlans: DataARPaymentPlanModel[] = [];
  doctorsInLedger: DoctorByTDOCIDModel[] = [];
  ledgerItemsSelected: number = 0;

  enumLedgerStatus: EnumValidValueItemModel[] = [];
  enumPaymentTypes: EnumValidValueItemModel[] = [];
  enumLedgerItemTypes: EnumValidValueItemModel[] = [];

  enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';
  //enumLedgerItemStatusPaid: string = '00000083-1000-0000-0000-000000000002';
  enumLedgerItemStatusVoid: string = '00000083-1000-0000-0000-000000000003';
  enumLedgerItemStatusOutstanding: string = '00000083-1000-0000-0000-000000000001';

  enumARLedgerItemOriginTypeTransaction: string = '00000207-1000-0000-0000-000000000003';
  enumARLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
  enumARLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';

  PatientStatementReport = ReportIDEnum.reportID_PatientStatement;
  WalkOutSlipReport = ReportIDEnum.reportID_FrontDesk_WalkOutSlip;
  LedgerFormReport = ReportIDEnum.reportID_LedgerFormReport;

  printingReportId: string | null = null;

  patientCredit: number = 0;
  insuranceCredit: number = 0;
  creditsObj: DataArLedgerCredits;

  activeSortDirection: string = 'dec';
  activeSortType: string = 'postDate';

  // <---filter variables - persistent
  activeFilterDoctorOn: boolean = false;
  activeFilterLocationOn: boolean = false;
  activeFilterDateRangeOn: boolean = false;
  activeFilterCodeOn: boolean = false;
  activeFilterToothOn: boolean = false;
  activeFilter: boolean = false;

  activeFilterDoctorId: string = 'All Doctors';
  activeFilterLocationId: string = 'All Locations';
  dRangeStart: Date = null;
  dRangeEnd: Date = null;
  activeFilterCodesSelected: string[] = [];
  activeFilterTeethSelected: string[] = [];
  range = new FormGroup({
    start: new FormControl<Date | null>(new Date(this.dRangeStart)),
    end: new FormControl<Date | null>(new Date(this.dRangeEnd)),
  });

  activeFilterDBString: string = '';
  ledgerFilterParamsName: string = 'LedgerFilterParameters';
  TDOUserParams: TdoUserParameters;
  // filter variables - persistent--->

  activeFilterLedgerItemFunctions = [];
  activeFilterOrganizer: any = {};
  doctorList: string[] = [];
  codeList: string[] = [];
  toothList: string[] = [];
  locationList: SelectTDOCIDLOCIDModel[] = [];

  codes = new UntypedFormControl({ value: [], disabled: !this.activeFilterCodeOn });
  teeth = new UntypedFormControl({ value: [], disabled: !this.activeFilterToothOn });

  // footer
  footerPatientEstimate: number;
  footerInsuranceEstimate: number;
  footerAdjustedPrice: number;
  footerPrice: number;
  footerPatientPayment: number;
  footerInsurancePayment: number;
  footerCreditAdjustments: number;
  footerDebitAdjustments: number;

  searchPredicate: (data: any, filter: string) => boolean;
  isCheckOut: boolean = false;
  TZID: string = '';
  tzOffsetMins: number = 0;

  // new ledger design
  // 'AmountDue', 'AmountDueInsurance', 'AmountDuePatient', 'PaymentsTotal', 'PaymentsTotalPatient', 'PaymentsTotalInsurance'
  // displayedColumns: string[] = ['PostDate', 'PostedBy', 'LocationName', 'DoctorName', 'TeethReference', 'Code', 'Description', 'Reference',
  //   'Price', 'PriceAdjusted', 'AmountDuePatient', 'AmountDueInsurance', 'PaymentsTotalPatient', 'PaymentsTotalInsurance', 'TotalCreditAdjustments', 'TotalDebitAdjustments', 'RunningBalance' ];
  displayedTableLayoutParamsName: string = 'LedgerTableColumnLayout';
  displayedColumns: string[] = [];
  displayedTableLayout: ARLedgerTableColumn[] = [];
  displayedTableLayoutString: string;
  TDOUserParamsTable: TdoUserParameters;
  selectedRowLedgerId: string = "";
  clickTimer: any;

  private overlayRef: OverlayRef | null;
  private sub: Subscription;
  subscriptions: Subscription[] = [];
  LEDGER_ITEM_TYPE = LEDGER_ITEM_TYPE;
  isPayableLedgerItem = isPayableLedgerItem;
  EnumARPaymentType = EnumARPaymentType;
  presavedIsSentCollection: boolean;
  presavedIsOnPaymentPlan: boolean;
  presavedIsChargeInterest: boolean;


  constructor(
    private readonly router: Router,
    private arService: ARService,
    private readonly dialog: MatDialog,
    private readonly dialogService: DialogService,
    private readonly currencyPipe: CurrencyPipe,
    public globals: Globals,
    public uiService: UiService,
    private readonly messagingService: MessagingService,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private readonly notesService: NotesService,
    private readonly authenticationService: AuthenticationService,
    private readonly route: ActivatedRoute,
    private readonly localStorageService: LocalStorageService,
    private readonly printService: TDOPrintService,
    private readonly fileManagerService: FileManagerService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.searchPredicate = (data: DataARLedgerListModel, filter: string) => {
      if (data.dataARTransactionItem) {
        return data.dataARTransactionItem.Code.toLowerCase().includes(filter) || data.Description.toLowerCase().includes(filter);
      }
      return data.Description.toLowerCase().includes(filter);
    };
  }

  async ngOnInit() {
    this.sub = this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.isCheckOut = params['isCheckOut'] || false;
      });
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_MINIMIZE, {});

    this.TZID = this.localStorageService.currentUserData.authdata.tzId;
    this.LOCID = Number.parseInt(localStorage.getItem('LOCID'));
    this.PatientCaseId = this.globals.currentPatientCaseId;
    this.PatientId = this.globals.currentPatientId;
    this.TDOUserID = this.localStorageService.currentUserData.authdata.userid;
    this.isLoading = true;
    try {
      await this.init(false);
      this.safeDetectChanges();
      // initially load and run any saved filters
      const codesSub = this.codes.valueChanges.subscribe(value => {
        if (this.activeFilterCodeOn) {
          this.filterLedgerItemsByCode();
        }
        else {
          if (this.codes.value.length) {
            this.codes.setValue([]);
          }
        }
      });

      this.subscriptions.push(codesSub);

      const teethSub = this.teeth.valueChanges.subscribe(value => {
        if (this.activeFilterToothOn) {
          this.filterLedgerItemsByTooth();
        }
        else {
          if (this.teeth.value.length) {
            this.teeth.setValue([]);
          }
        }
      });

      this.subscriptions.push(teethSub);
      if (this.TDOUserParams && this.TDOUserParams.ParameterValue) {
        this.activeFilterDBString = this.TDOUserParams.ParameterValue;
        this.initFilter(false);
      }

    } catch (err) {
      console.error("Error in ArLedgerComponent ngOnInit", err);
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
    }

    this.resetNotesFilter();
    // listening to when notes component is ready to be filtered
    const messagingSub = this.messagingService.componentMessageCall
      .subscribe(response => {

        if (response.event === MessagingConstants.LEDGER_REFRESH) {
          // Reload ledger data using the same patient and case          
          this.init(false); // reload data for the new patient
        }

        if (response.event === MessagingConstants.PATIENT_CHANGED) {
          this.resetData(); // set new patient data
          this.isLoading = true;
          this.init(false); // reload data for the new patient
        }
      });

    this.subscriptions.push(messagingSub);
    // table layout default
    this.initTableLayout();

    // total patient and insurance estimates to be shown in table footer
    this.totalPatientInsuranceEstimates();
  }

  totalPatientInsuranceEstimates() {
    // element.enumARLedgerItemTypeID === this.enumLedgerItemTypeDebit ? (element.AmountDuePatient | currency)
    const tableData = this.dataLedgerItemsTable.applyMultipleFilters(this.activeFilterLedgerItemFunctions);
    this.footerInsuranceEstimate = 0;
    this.footerPatientEstimate = 0;
    this.footerAdjustedPrice = 0;
    this.footerPrice = 0;
    this.footerPatientPayment = 0;
    this.footerInsurancePayment = 0;
    this.footerCreditAdjustments = 0;
    this.footerDebitAdjustments = 0;
    if (tableData) {
      tableData.forEach(a => {
        if (a.enumLedgerItemStatusID != LEDGER_ITEM_STATUS.Void) {
          if (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit) {
            this.footerCreditAdjustments = this.footerCreditAdjustments + a.TotalCreditAdjustments;
            this.footerPatientEstimate = this.footerPatientEstimate + a.AmountDuePatient;
            this.footerInsuranceEstimate = this.footerInsuranceEstimate + a.AmountDueInsurance;
            this.footerAdjustedPrice = this.footerAdjustedPrice + a.dataARTransactionItemList.DoctorsPrice;
            this.footerPrice = this.footerPrice + a.dataARTransactionItemList.Price;
          }
          else if (isPayableLedgerItem(a)) {
            // interest / late fee: paid on its own row, so it adds to the patient estimate
            this.footerPatientEstimate = this.footerPatientEstimate + a.AmountDuePatient;
          }
          else if (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditPayment) {
            this.footerPatientPayment = this.footerPatientPayment + a.PaymentsTotalPatient;
            this.footerInsurancePayment = this.footerInsurancePayment + a.PaymentsTotalInsurance;
          }
          else if (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.SurchargePayment) {
            this.footerPatientPayment = this.footerPatientPayment + a.PaymentsTotalPatient;
          }
          else if (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Surcharge) {
            this.footerDebitAdjustments = this.footerDebitAdjustments + a.TotalDebitAdjustments;
          }
          else if (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Credit  || a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.WriteOff || a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditAdjustment) {
            this.footerCreditAdjustments = this.footerCreditAdjustments + a.TotalCreditAdjustments;
          }
          else if (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.DebitAdjustment || a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Refund) {
            this.footerDebitAdjustments = this.footerDebitAdjustments + a.TotalDebitAdjustments;
          }
        }
      });
    }
  }

  saveFilterToString() {
    // load any saved filter values from global
    const filterObj = {};

    // filter on/off
    if (this.hideVoidedLedgerItems) { Object.assign(filterObj, { activeFilterVoidOn: 1 }); }
    else { Object.assign(filterObj, { activeFilterVoidOn: 0 }); }

    if (this.activeFilterDoctorOn) { Object.assign(filterObj, { activeFilterDoctorOn: 1 }); }
    else { Object.assign(filterObj, { activeFilterDoctorOn: 0 }); }

    if (this.activeFilterLocationOn) { Object.assign(filterObj, { activeFilterLocationOn: 1 }); }
    else { Object.assign(filterObj, { activeFilterLocationOn: 0 }); }

    if (this.activeFilterDateRangeOn) { Object.assign(filterObj, { activeFilterDateRangeOn: 1 }); }
    else { Object.assign(filterObj, { activeFilterDateRangeOn: 0 }); }

    if (this.activeFilterCodeOn) { Object.assign(filterObj, { activeFilterCodeOn: 1 }); }
    else { Object.assign(filterObj, { activeFilterCodeOn: 0 }); }

    if (this.activeFilterToothOn) { Object.assign(filterObj, { activeFilterToothOn: 1 }); }
    else { Object.assign(filterObj, { activeFilterToothOn: 0 }); }

    // filter values
    if (this.activeFilterDoctorId) { Object.assign(filterObj, { activeFilterDoctorId: this.activeFilterDoctorId }); }
    if (this.activeFilterLocationId) { Object.assign(filterObj, { activeFilterLocationId: this.activeFilterLocationId }); }
    if (this.dRangeStart) { Object.assign(filterObj, { activeFilterDateRangeStart: this.dRangeStart }); }
    if (this.dRangeEnd) { Object.assign(filterObj, { activeFilterDateRangeEnd: this.dRangeEnd }); }
    if (this.activeFilterTeethSelected && this.activeFilterTeethSelected.length > 0) {
      Object.assign(filterObj, { activeFilterTeethSelected: this.activeFilterTeethSelected });
    }
    if (this.activeFilterCodesSelected && this.activeFilterCodesSelected.length > 0) {
      Object.assign(filterObj, { activeFilterCodesSelected: this.activeFilterCodesSelected });
    }

    this.activeFilterDBString = JSON.stringify(filterObj);

    this.saveFilterStringToGlobal();
  }

  saveFilterStringToGlobal() {
    const filterObj = JSON.parse(this.activeFilterDBString);

    if (filterObj.activeFilterVoidOn) { this.globals.ledgerActiveFilterVoidOn = filterObj.activeFilterVoidOn; }
    if (filterObj.activeFilterDoctorOn) { this.globals.ledgerActiveFilterDoctorOn = filterObj.activeFilterDoctorOn; }
    if (filterObj.activeFilterLocationOn) { this.globals.ledgerActiveFilterLocationOn = filterObj.activeFilterLocationOn; }
    if (filterObj.activeFilterDateRangeOn) { this.globals.ledgerActiveFilterDateRangeOn = filterObj.activeFilterDateRangeOn; }
    if (filterObj.activeFilterToothOn) { this.globals.ledgerActiveFilterToothOn = filterObj.activeFilterToothOn; }
    if (filterObj.activeFilterCodeOn) { this.globals.ledgerActiveFilterCodeOn = filterObj.activeFilterCodeOn; }

    if (filterObj.activeFilterDoctorId) { this.globals.ledgerActiveFilterDoctorId = filterObj.activeFilterDoctorId; }
    if (filterObj.activeFilterLocationId) { this.globals.ledgerActiveFilterLocationId = filterObj.activeFilterLocationId; }
    if (filterObj.activeFilterDateRangeStart) { this.globals.ledgerActiveFilterDateRangeStart = filterObj.activeFilterDateRangeStart; }
    if (filterObj.activeFilterDateRangeEnd) { this.globals.ledgerActiveFilterDateRangeEnd = filterObj.activeFilterDateRangeEnd; }
    if (filterObj.activeFilterTeethSelected) { this.globals.ledgerActiveFilterTeeth = filterObj.activeFilterTeethSelected; }
    if (filterObj.activeFilterCodesSelected) { this.globals.ledgerActiveFilterCodes = filterObj.activeFilterCodesSelected; }
  }

  initFilter(saveFilter: boolean = true) {
    // set db saved filter settings to globals
    this.saveFilterStringToGlobal();

    // next, set filter from globals...
    // voids
    if (this.globals.ledgerActiveFilterVoidOn) {
      if (this.globals.ledgerActiveFilterVoidOn === '1') { this.hideVoidedLedgerItems = true; }
      else { this.hideVoidedLedgerItems = false; }
    }
    // doctor
    if (this.globals.ledgerActiveFilterDoctorOn) {
      if (this.globals.ledgerActiveFilterDoctorOn === '1') { this.activeFilterDoctorOn = true; }
      else { this.activeFilterDoctorOn = false; }
    }
    if (this.globals.ledgerActiveFilterDoctorId) {
      this.activeFilterDoctorId = this.globals.ledgerActiveFilterDoctorId;
    }
    // location
    if (this.globals.ledgerActiveFilterLocationOn) {
      if (this.globals.ledgerActiveFilterLocationOn === '1') { this.activeFilterLocationOn = true; }
      else { this.activeFilterLocationOn = false; }
    }
    if (this.globals.ledgerActiveFilterLocationId) { this.activeFilterLocationId = this.globals.ledgerActiveFilterLocationId; }

    // date
    if (this.globals.ledgerActiveFilterDateRangeOn) {
      if (this.globals.ledgerActiveFilterDateRangeOn === '1') { this.activeFilterDateRangeOn = true; }
      else { this.activeFilterDateRangeOn = false; }
    }
    if (this.globals.ledgerActiveFilterDateRangeStart) {
      this.dRangeStart = new Date(this.globals.ledgerActiveFilterDateRangeStart);
      // this.range.value.start = this.dRangeStart;
    }
    if (this.globals.ledgerActiveFilterDateRangeEnd) {
      this.dRangeEnd = new Date(this.globals.ledgerActiveFilterDateRangeEnd);
      // this.range.value.end = this.dRangeEnd;
    }
    this.range = new FormGroup({
      start: new FormControl<Date | null>(new Date(this.dRangeStart)),
      end: new FormControl<Date | null>(new Date(this.dRangeEnd)),
    });
    // tooth
    if (this.globals.ledgerActiveFilterToothOn) {
      if (this.globals.ledgerActiveFilterToothOn === '1') { this.activeFilterToothOn = true; }
      else { this.activeFilterToothOn = false; }
    }
    if (this.globals.ledgerActiveFilterTeeth && this.globals.ledgerActiveFilterTeeth.length > 0) {
      this.activeFilterTeethSelected = this.globals.ledgerActiveFilterTeeth;
      this.teeth.setValue(this.activeFilterTeethSelected);
    }

    // code
    if (this.globals.ledgerActiveFilterCodeOn) {
      if (this.globals.ledgerActiveFilterCodeOn === '1') { this.activeFilterCodeOn = true; }
      else { this.activeFilterCodeOn = false; }
    }
    if (this.globals.ledgerActiveFilterCodes && this.globals.ledgerActiveFilterCodes.length > 0) {
      this.activeFilterCodesSelected = this.globals.ledgerActiveFilterCodes;
      this.codes.setValue(this.activeFilterCodesSelected);
    }

    // apply any filters that are turned on
    if (this.activeFilterDoctorOn) { this.filterLedgerItemsByDoctor(false); }
    if (this.activeFilterLocationOn) { this.filterLedgerItemsByLocation(false); }
    if (this.activeFilterDateRangeOn) { this.filterLedgerItemsByDateRange(false); }
    if (this.activeFilterToothOn) { this.filterLedgerItemsByTooth(false); }
    if (this.activeFilterCodeOn) { this.filterLedgerItemsByCode(false); }
    if (this.hideVoidedLedgerItems) { this.filterOutItemsByVoided(this.hideVoidedLedgerItems, false); }
    this.applyFilters(saveFilter);
  }

  initTableLayout() {
    // table layout

    const layout = this.globals.currentLedgerTableLayout;
    if (layout && layout.length > 0) {
      this.displayedTableLayout = this.globals.currentLedgerTableLayout;
    }
    else {
      // load default

      //////////////////////////////////////////////////////////
      // group 1
      const colGroup1 = new ARLedgerTableColumn();
      colGroup1.headerName = 'Post';
      colGroup1.colspan = 2;
      colGroup1.isGroupColumn = true;
      colGroup1.matColumnDef = 'header-row-post-group';

      const colGroup1child1 = new ARLedgerTableColumn();
      colGroup1child1.headerName = 'Date';
      colGroup1child1.matColumnDef = 'PostDate';
      colGroup1.childColumns.push(colGroup1child1);

      const colGroup1child2 = new ARLedgerTableColumn();
      colGroup1child2.headerName = 'User';
      colGroup1child2.matColumnDef = 'PostedBy';
      colGroup1.childColumns.push(colGroup1child2);

      //////////////////////////////////////////////////////////
      // group 2
      const colGroup2 = new ARLedgerTableColumn();
      colGroup2.headerName = 'Ungrouped';
      colGroup2.colspan = 6;
      colGroup2.isGroupColumn = true;
      colGroup2.matColumnDef = 'header-row-first-blank-group';

      const colGroup2child1 = new ARLedgerTableColumn();
      colGroup2child1.headerName = 'Location';
      colGroup2child1.matColumnDef = 'LocationName';
      colGroup2.childColumns.push(colGroup2child1);

      const colGroup2child2 = new ARLedgerTableColumn();
      colGroup2child2.headerName = 'Doctor';
      colGroup2child2.matColumnDef = 'DoctorName';
      colGroup2.childColumns.push(colGroup2child2);

      const colGroup2child3 = new ARLedgerTableColumn();
      colGroup2child3.headerName = 'Tooth';
      colGroup2child3.matColumnDef = 'TeethReference';
      colGroup2.childColumns.push(colGroup2child3);

      const colGroup2child4 = new ARLedgerTableColumn();
      colGroup2child4.headerName = 'Code';
      colGroup2child4.matColumnDef = 'Code';
      colGroup2.childColumns.push(colGroup2child4);

      const colGroup2child5 = new ARLedgerTableColumn();
      colGroup2child5.headerName = 'Description';
      colGroup2child5.matColumnDef = 'Description';
      colGroup2.childColumns.push(colGroup2child5);

      const colGroup2child6 = new ARLedgerTableColumn();
      colGroup2child6.headerName = 'Reference';
      colGroup2child6.matColumnDef = 'Reference';
      colGroup2.childColumns.push(colGroup2child6);

      //////////////////////////////////////////////////////////
      // group 3
      const colGroup3 = new ARLedgerTableColumn();
      colGroup3.headerName = 'Fee';
      colGroup3.colspan = 2;
      colGroup3.isGroupColumn = true;
      colGroup3.matColumnDef = 'header-row-fee-group';

      const colGroup3child1 = new ARLedgerTableColumn();
      colGroup3child1.headerName = 'Standard';
      colGroup3child1.matColumnDef = 'Price';
      colGroup3.childColumns.push(colGroup3child1);

      const colGroup3child2 = new ARLedgerTableColumn();
      colGroup3child2.headerName = 'Contracted';
      colGroup3child2.matColumnDef = 'PriceAdjusted';
      colGroup3.childColumns.push(colGroup3child2);

      //////////////////////////////////////////////////////////
      // group 4
      const colGroup4 = new ARLedgerTableColumn();
      colGroup4.headerName = 'Estimate Due';
      colGroup4.colspan = 2;
      colGroup4.isGroupColumn = true;
      colGroup4.matColumnDef = 'header-row-estimate-group';

      const colGroup4child1 = new ARLedgerTableColumn();
      colGroup4child1.headerName = 'Patient';
      colGroup4child1.matColumnDef = 'AmountDuePatient';
      colGroup4.childColumns.push(colGroup4child1);

      const colGroup4child2 = new ARLedgerTableColumn();
      colGroup4child2.headerName = 'Insurance';
      colGroup4child2.matColumnDef = 'AmountDueInsurance';
      colGroup4.childColumns.push(colGroup4child2);

      //////////////////////////////////////////////////////////
      // group 5
      const colGroup5 = new ARLedgerTableColumn();
      colGroup5.headerName = 'Payments';
      colGroup5.colspan = 2;
      colGroup5.isGroupColumn = true;
      colGroup5.matColumnDef = 'header-row-payment-group';

      const colGroup5child1 = new ARLedgerTableColumn();
      colGroup5child1.headerName = 'Patient';
      colGroup5child1.matColumnDef = 'PaymentsTotalPatient';
      colGroup5.childColumns.push(colGroup5child1);

      const colGroup5child2 = new ARLedgerTableColumn();
      colGroup5child2.headerName = 'Insurance';
      colGroup5child2.matColumnDef = 'PaymentsTotalInsurance';
      colGroup5.childColumns.push(colGroup5child2);

      //////////////////////////////////////////////////////////
      // group 6
      const colGroup6 = new ARLedgerTableColumn();
      colGroup6.headerName = 'Adjustments';
      colGroup6.colspan = 2;
      colGroup6.isGroupColumn = true;
      colGroup6.matColumnDef = 'header-row-adjustment-group';

      const colGroup6child1 = new ARLedgerTableColumn();
      colGroup6child1.headerName = 'Credit';
      colGroup6child1.matColumnDef = 'TotalCreditAdjustments';
      colGroup6.childColumns.push(colGroup6child1);

      const colGroup6child2 = new ARLedgerTableColumn();
      colGroup6child2.headerName = 'Debit';
      colGroup6child2.matColumnDef = 'TotalDebitAdjustments';
      colGroup6.childColumns.push(colGroup6child2);

      //////////////////////////////////////////////////////////
      // group 7
      const colGroup7 = new ARLedgerTableColumn();
      colGroup7.headerName = 'Ungrouped';
      colGroup7.isGroupColumn = true;
      colGroup7.matColumnDef = 'header-row-second-blank-group';

      const colGroup7child1 = new ARLedgerTableColumn();
      colGroup7child1.headerName = 'Running Balance';
      colGroup7child1.matColumnDef = 'RunningBalance';
      colGroup7.childColumns.push(colGroup7child1);

      // finally push them all to displayedTableLayout
      this.displayedTableLayout = [];

      this.displayedTableLayout.push(colGroup1);
      this.displayedTableLayout.push(colGroup2);
      this.displayedTableLayout.push(colGroup3);
      this.displayedTableLayout.push(colGroup4);
      this.displayedTableLayout.push(colGroup5);
      this.displayedTableLayout.push(colGroup6);
      this.displayedTableLayout.push(colGroup7);
    }

    this.updateTableLayout();
  }

  updateTableLayout() {
    // loop though model and build displayed columns string array
    this.displayedColumns = [];
    this.displayedTableLayout.filter(f => f.isGroupColumn && f.showColumn).forEach(a => {
      a.colspan = a.childColumns.filter(f => f.showColumn).length;
      a.childColumns.filter(f => f.showColumn).forEach(aa => {
        this.displayedColumns.push(aa.matColumnDef);
      });
    });
  }

  ngAfterViewInit() {
  }

  resetData() {
    this.LOCID = parseInt(localStorage.getItem('LOCID'));
    this.PatientCaseId = this.globals.currentPatientCaseId;
    this.PatientId = this.globals.currentPatientId;
  }

  // what happens when you go to void a ledger item that is part of a payment plan???
  onRightClickContextEvent(event, ledgerItem: DataARLedgerListModel) {

    if (ledgerItem.DATA_IS_IN_PLAN
      || ledgerItem.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Void) {
      return;
    }

    this.contextPositionX = event.clientX;
    this.contextPositionY = event.clientY;
    const voidButton = new ContextButton('voidItem', 'Mark as void', false, ledgerItem);
    this.contextMenuButtons = [voidButton];
    this.showContext = true;
  }

  async handleContextEvent(event: ContextEvent) {

    if (event.eventType === 'close') {
      this.showContext = false;
      return;
    }

    if (event.eventIdentifier === 'voidItem') {
      const cancelActionButton: ConfirmActionButton = new ConfirmActionButton('cancel', 'Cancel', event.eventPayload, 'warn', false);
      const confirmActionButton: ConfirmActionButton = new ConfirmActionButton('confirm', 'Confirm', event.eventPayload, 'primary', true);
      const actionButtons: ConfirmActionButton[] = [confirmActionButton, cancelActionButton];
      const confirmResult: any = await this.openConfirmComponent(actionButtons, 'Are you sure you want to void this ledger item?', true);

      if (confirmResult && confirmResult.eventIdentifier === 'confirm') {
        const ledgerItem: DataARLedgerListModel = event.eventPayload;
        ledgerItem.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Void;
        try {
          this.createMessage('Ledger item marked as void', 'Success');
        } catch (err) {
          console.error('Error in ArLedgerComponent handlecontextevent', err);
          this.createMessage('Something went wrong', 'Error');
        }
        await this.init();
        this.initTableLayout();
      }
    }

    this.showContext = false;
  }

  navigateToAr() {
    this.router.navigate(['/ar/feeCalculation']);
  }

  openConfirmComponent(actionButtons: ConfirmActionButton[], message: string, inlineButtons: boolean) {
    const promise = new Promise((resolve, reject) => {
      const dialogRef = this.dialog.open(GeneralConfirmComponent, {
        width: '450px',
        height: '200px',
        data: {
          actionButtons,
          message,
          inlineButtons,
        }
      });
      const confSub = dialogRef.afterClosed().subscribe(result => {
        resolve(result);
      }, err => {
        resolve(false);
      });

      this.subscriptions.push(confSub);
    });
    return promise;
  }

  openPaymentPlanWindow() {
    const dialogRef = this.dialog.open(PlanListComponent, {
      width: '90%',
      height: '90%',
      data: {
        PatientId: this.PatientId,
        ledgerItems: this.dataLedgerItems,
      }
    });
    const paymentSub = dialogRef.afterClosed().subscribe(async result => {
      try {
        await this.init();
        this.initTableLayout();
      } catch (err) {
        console.error('Error in payment plan dialog result:', err);
      }
    }, async err => {
      try {
        await this.init();
        this.initTableLayout();
      } catch (e) {
        console.error('Error in payment plan dialog error handler:', e);
      }
    });
    this.subscriptions.push(paymentSub);
  }

  openAdjustmentWindow(type: string) {
    const dialogRef = this.dialog.open(CreateAdjustment2Component, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        type,
        PatientId: this.PatientId,
        dataLedgerItems: this.dataLedgerItems
      }
    });
    const adjustSub = dialogRef.afterClosed().subscribe(async result => {
      try {
        if (result) {
          await this.init();
          this.initTableLayout();
        }
      } catch (err) {
        console.error('Error in adjustment dialog:', err);
      }
    });
    this.subscriptions.push(adjustSub);
  }

  openTableColumnWindow() {
    const dialogRef = this.dialog.open(ArLedgerTableLayoutManagerComponent, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        displayedTableLayout: this.displayedTableLayout
      }
    });
    const tableSub = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.displayedTableLayout = result;
        this.updateTableLayout();
        this.safeDetectChanges();
      }
    }, err => {
    });
    this.subscriptions.push(tableSub);
  }

  openPaymentInvoice(paymentDistrib) {
    const dialogRef = this.dialog.open(ArPaymentInvoiceGeneratorComponent, {
      width: '90%',
      height: '90%',
      data: {
        patientMode: false,
        paymentId: paymentDistrib.PaymetnID,
        dataPatient: this.dataPatient,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    }, err => {
    });
  }


  getAppointmentInformation(PatientCaseId: string) {
    return this.arService.getAppointmentInformation(PatientCaseId).toPromise();
  }

  async init(applySort: boolean = false) {

    this.isLoading = true;
    const promises: any[] = [
      this.getPatientAndContact(this.PatientId),
      this.getLedgerForPatient2(this.PatientId),
      this.getLedgerTypes(),
      this.getEnumValidValueItemsByValidValueName('enumARPayementType'),
      this.getEnumValidValueItemsByValidValueName('enumLedgerItemStatus'),
      this.getPaymentPlansForPatient(this.PatientId),
      this.getDoctorsByPatientLedger(this.PatientId),
      this.getCreditsForLedger(this.PatientId),
      this.arService.getUserParams(this.TDOUserID, this.ledgerFilterParamsName).toPromise(),
      this.arService.getUserParams(this.TDOUserID, this.displayedTableLayoutParamsName).toPromise()
    ];

    


    try {
      const results: any[] = await Promise.all(promises);

      this.dataPatient = results[0];
      this.dataContact = this.dataPatient.dataContact;
      this.dataLedgerItems = results[1];
      this.bkDataLedgerItems = this.dataLedgerItems;
      // this.dataLedgerItemsTable = this.dataLedgerItems;
      this.enumLedgerItemTypes = results[2];
      this.enumPaymentTypes = results[3];
      this.enumLedgerStatus = results[4];
      this.paymentPlans = results[5];
      this.doctorsInLedger = results[6];
      this.creditsObj = results[7];
      this.TDOUserParams = results[8];
      this.TDOUserParamsTable = results[9];

      this.generateDoctorList();
      this.generateLocationList();
      this.generateCodeList();
      this.generateToothList();

      this.dataLedgerItems.forEach(ledgerItem => {
        ledgerItem.DATA_SELECTED = false;
        ledgerItem.DATA_SELECTED_CLAIM = false;
      });

      // de-serialize table layout string from db
      if (this.TDOUserParamsTable && this.TDOUserParamsTable.ParameterValue) {
        this.displayedTableLayoutString = this.TDOUserParamsTable.ParameterValue;
        this.displayedTableLayout = JSON.parse(this.displayedTableLayoutString);
        this.globals.currentLedgerTableLayout = this.displayedTableLayout;
      }

      // only show certain ledger items in table
      this.dataLedgerItemsTable = this.dataLedgerItems.filter(a => a.isShowOnLedger === true);

      // set balance info --
      // 2024-11-26 Removed as footer is not displayed in HTML
      //this.updateSummary(this.dataLedgerItems);

      // set patient flags
      this.isCollections = this.dataPatient.isSentCollection;
      this.isPaymentPlan = this.dataPatient.isOnPaymentPlan;
      this.isInterest = this.dataPatient.isChargeInterest;
      this.presavedIsSentCollection = this.isCollections;
      this.presavedIsOnPaymentPlan = this.isPaymentPlan;
      this.presavedIsChargeInterest = this.isInterest;
      setTimeout(() => {
        this.isLoading = false;
        this.safeDetectChanges();
      }, 50);
      // async load active claims for fees
      this.updateClaimStatusForFees();

      setTimeout(() => {
        if (this.isCheckOut && !this.isLoading) {
          this.isCheckOut = false;
          this.openPaymentComponent('patient');
        }
      }, 1000);

      //2024/11/26 - Moved to call to get ledger items, same logic
      // save patient balance to dataPatient
      //const balancePromise: any[] = [ this.arService.updatePatientBalance2(this.PatientId).toPromise() ];
      //const balancePromiseResults: any[] = await Promise.all(balancePromise);
      //const balancePromiseResult: number = results[0];

      // total patient and insurance estimates to be shown in table footer
      this.totalPatientInsuranceEstimates();

      // Check for EOB documents on insurance payment ledger items
      this.checkForEOBDocuments();

    } catch (err) {
      console.error('Error in ArLedgerComponent init', err);
      this.isLoading = false;
      this.createMessage('Something went wrong', 'Error');
      this.safeDetectChanges();
    }
  }

  async updateClaimStatusForFees() {

    for (const a of this.dataLedgerItemsTable.filter(b => b.ARClaimID)) {
      if (a.enumClaimStatusID === null) {
        const promises: any[] = [this.arService.getClaimStatus(a.ARClaimID).toPromise()];
        const results: any[] = await Promise.all(promises);
        const result: string = results[0];

        a.enumClaimStatusID = result;
        if (result !== ClaimStatusEnum.Canceled) {
          a.ARClaimIsActive = true;
        }
        else {
          a.ARClaimIsActive = false;
        }
      }
    }
  }

  calculateLedgerBalance() {
    let balance: number = 0;

    this.dataLedgerItems.forEach(ledgerItem => {
      if (ledgerItem.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Void) {
        // do nothing
      } else if (ledgerItem.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Credit) {
        balance -= ledgerItem.Amount;
      } else if (ledgerItem.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit) {
        balance += ledgerItem.Amount;
      }
    });

    // now we need to do something when it has a payment plan?

    return balance;
  }

  getEnumValidValueItemsByValidValueName(ValidValueName: string) {
    return this.arService.getEnumValidValueItemsByValidValueName(ValidValueName).toPromise();
  }

  returnLedgerItemType(ledgerItem) {

    const itemType: EnumValidValueItemModel = this.enumLedgerItemTypes.find(type => {
      return type.ValidValueItemId === ledgerItem.enumARLedgerItemTypeID;
    });

    if (itemType) {
      return itemType.ItemDisplayValue;
    }

    return '-';
  }

  getLedgerTypes() {
    return this.arService.getEnumValidValueItemsByValidValueName('enumARLedgerItemType').toPromise();
  }

  returnDiscountForLedgerItem(ledgerItem) {

    const enumCalcTypePercent: string = '00000048-1000-0000-0000-000000000001';
    const enumCalcTypeAmount: string = '00000048-1000-0000-0000-000000000002';

    if (!ledgerItem.dataARTransactionItem) {
      return '-';
    }

    if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCalcTypePercent) {

      if (ledgerItem.dataARTransactionItem.DiscountPCT == null) {
        return 'Add discount';
      } else {
        return `${ledgerItem.dataARTransactionItem.DiscountPCT}%`;
      }

    } else if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCalcTypeAmount) {

      if (ledgerItem.dataARTransactionItem.DiscountAmount == null) {
        return 'Add discount';
      } else {
        let num = parseInt(ledgerItem.dataARTransactionItem.DiscountAmount).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        num = `${num}`.replace('.00', '');
        return num;
      }

    } else {
      return 'Add discount';
    }

  }


  returnLedgerAdjustmentType(ledgerItem: DataARLedgerListModel) {

    if (ledgerItem.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit) {
      return 'Debit Adjustment';
    } else {
      return 'Credit Adjustment';
    }

  }

  openDiscountForLedgerItem(ledgerItem: DataARLedgerListModel) {

    if (ledgerItem.DATA_IS_IN_PLAN) {
      return;
    }

    if (!ledgerItem.dataARTransactionItem) {
      return;
    }

    const dialogRef = this.dialog.open(ArDiscountComponent, {
      width: '900px',
      height: '500px',
      data: {
        ledgerItem,
      }
    });
    const discountSub = dialogRef.afterClosed().subscribe(async result => {
      try {
        if (result) {
          await this.init();
          this.initTableLayout();
        }
      } catch (err) {
        console.error('Error in discount dialog:', err);
      }
    });
    this.subscriptions.push(discountSub);
  }

  openClaimComponent() {
    const dataLedgerItems: DataARLedgerListModel[] = this.dataLedgerItems.filter(ledgerItem => {
      return ledgerItem.DATA_SELECTED_CLAIM;
    });

    const dialogRef = this.dialog.open(ArInsuranceClaimsComponent, {
      width: '90%',
      height: '90%',
      data: {
        PatientId: this.PatientId,
        dataLedgerItems,
        dataPatient: this.dataPatient,
        dataContact: this.dataContact,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    }, err => {
    });
  }

  openPaymentComponent(type: string) {
    // ledger items
    let dataLedgerItems: DataARLedgerListModel[] = [];
    dataLedgerItems = this.dataLedgerItems;

    // don't send the items that are in a plan
    dataLedgerItems = dataLedgerItems.filter(item => {
      return !item.DATA_IS_IN_PLAN;
    });

    if (type === 'patient') {
      const dialogRef = this.dialog.open(ArPaymentComponent, {
        width: '90%',
        panelClass: 'dialog',
        disableClose: true, // prevents dialog closing as a result of an outside click
        data: {
          type: 'Patient',
          PatientId: this.PatientId,
          dataLedgerItems,
          dataPatient: this.dataPatient,
          dataContact: this.dataContact,
        }
      });
      const paymentCompSub = dialogRef.afterClosed().subscribe({
        next: async result => {
          try {
            if (result) {
              this.isLoading = true;
              setTimeout(() => void this.init()
                .then(() => this.initTableLayout())
                .catch(err => console.error('Error refreshing ledger after payment dialog:', err)), 1500);
            }
          } catch (err) {
            console.error('Error in openPaymentComponent dialog:', err);
          }
        }
      });
      this.subscriptions.push(paymentCompSub);
    }
    else if (type === 'insurance') {
      // this.router.navigateByUrl('landing/insurance-payment');

      const dialogRef = this.dialog.open(ArInsurancePaymentComponent, {
        width: '90%',
        height: '875px',
        panelClass: 'dialog',
        disableClose: true, // prevents dialog closing as a result of an outside click
        data: {
          // type: 'insurance-claim-refusal',
          // PatientId: this.PatientId,
          // LedgerItem: ledgerItem,
        }
      });
      const insurancePaymentCompSub = dialogRef.afterClosed().subscribe({
        next: async result => {
          try {
            if (result) {
              this.isLoading = true;
              setTimeout(() => void this.init()
                .then(() => this.initTableLayout())
                .catch(err => console.error('Error refreshing ledger after payment dialog:', err)), 1500);
            }
          } catch (err) {
            console.error('Error in insurancePaymentComponent dialog:', err);
          }
        }
      });
      
      this.subscriptions.push(insurancePaymentCompSub);
    }
  }

  openPaymentPlansList() {
    const dialogRef = this.dialog.open(PlanViewComponent, {
      width: '90%',
      height: '90%',
      data: {
      }
    });
    const paymentPlanSub = dialogRef.afterClosed().subscribe(async result => {
      try {
        if (result) {
          await this.init();
          this.initTableLayout();
        }
      } catch (err) {
        console.error('Error in payment plan dialog:', err);
      }
    });
    this.subscriptions.push(paymentPlanSub);
  }

  openInterestFees() {
    const dialogRef = this.dialog.open(InterestAndLateFeesComponent, {
      width: '1400px',
      height: '800px',
      panelClass: 'dialog',
      autoFocus: false,
      disableClose: false,
      data: {
        PatientId: this.PatientId,
        PatientCaseId: this.PatientCaseId,
        dataLedgerItems: this.dataLedgerItems
      }
    });
    
    const interestFeesSub = dialogRef.afterClosed().subscribe(async result => {
      try {
        if (result) {
          await this.init();
          this.initTableLayout();
        }
      } catch (err) {
        console.error('Error in interest and late fees dialog:', err);
      }
    });
    
    this.subscriptions.push(interestFeesSub);
  }

  calcAdjustedPrice(ledgerItem: DataARLedgerListModel) {
    const enumCoverageTypePCT: string = '00000048-1000-0000-0000-000000000001';

    if (!ledgerItem.dataARTransactionItem) {
      return ledgerItem.Amount;
    }

    if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCoverageTypePCT) {

      if (ledgerItem.dataARTransactionItem.DiscountPCT == null || typeof ledgerItem.dataARTransactionItem.DiscountPCT === 'undefined') {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount * ((ledgerItem.dataARTransactionItem.DiscountPCT) / 100);
      }

    }

    if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === this.enumCoverageTypeAmount) {

      if (ledgerItem.dataARTransactionItem.DiscountAmount == null || typeof ledgerItem.dataARTransactionItem.DiscountAmount === 'undefined') {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount - ledgerItem.dataARTransactionItem.DiscountAmount;
      }

    }

    return ledgerItem.Amount;

  }

  calculateCredit(ledgerItem: DataARLedgerListModel) {

    let creditAmount = 0;

    ledgerItem.dataARPaymentDistribs.forEach(paymentDistrib => {
      creditAmount += paymentDistrib.Amount;
    });

    return creditAmount;
  }

  calculateBalance(ledgerItem) {
    const creditAmount = this.calculateCredit(ledgerItem);
    return ledgerItem.Amount - creditAmount;
  }

  calculateTotalCostForPayments() {
    let totalCost = 0;
    this.dataLedgerItems.forEach(ledgerItem => {
      if (ledgerItem.DATA_SELECTED) {
        totalCost += ledgerItem.Amount;
      }
    });
    return totalCost;
  }

  getLedgerItemStatus(ledgerItem: DataARLedgerListModel) {

    let status = '';

    const validValue = this.enumLedgerStatus.find(value => {
      return value.ValidValueItemId === ledgerItem.enumLedgerItemStatusID;
    });

    if (validValue) {
      status = validValue.ItemDisplayValue;
    }

    if (ledgerItem.DATA_IS_IN_PLAN) {
      status += ' in plan';
      return status;
    }

    return '-';
  }

  createMessage(message, type) {
    this.uiService.displayMessage(type, message);
  }

  calcClaimsSelected() {
    let flag = false;

    this.dataLedgerItems.forEach(ledgerItem => {
      if (ledgerItem.DATA_SELECTED_CLAIM) {
        flag = true;
      }
    });

    return flag;
  }

  calcLedgersSelected() {
    let flag = false;

    this.dataLedgerItems.forEach(ledgerItem => {
      if (ledgerItem.DATA_SELECTED) {
        flag = true;
      }
    });

    return flag;
  }

  convertUTCDatetoTimezone(date: Date, tz: string) {
    date = ConversionUtilities.getAdjustedTimezoneDate(date, tz);
    return date;
  }

  convertUTCDateToLocalDateFromString(dateString) {
    if (!dateString) {
      return null;
    }

    const date = new Date(dateString);
    return this.convertUTCDateToLocalDate(date);
  }

  convertUTCDateToLocalDate(date) {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }

  getPatientAndContact(PatientId: string) {
    return this.arService.getPatientAndContact(PatientId).toPromise();
  }

  getLedgerForPatient(PatientId: string) {
    return this.arService.getLedgerForPatient(PatientId).toPromise();
  }

  getLedgerForPatient2(PatientId: string) {
    return this.arService.getLedgerForPatient2(PatientId).toPromise();
  }

  getPaymentMethodFromPayment(paymentDistrib) {

    const validValue = this.enumPaymentTypes.find(value => {
      return value.ValidValueItemId === paymentDistrib.dataARPayment.enumPayementTypeID;
    });

    if (validValue) {
      return validValue.ItemDisplayValue;
    }

    return '-';
  }

  editDetailForLedger(ledgerItem: DataARLedgerListModel, key: string) {
    ledgerItem[key] = true;
  }

  async saveDetailForLedger(ledgerItem: DataARLedgerListModel, key: string) {
    ledgerItem[key] = false;

    try {
      const ledgerItemClone = JSON.parse(JSON.stringify(ledgerItem));
      ledgerItemClone.dataARPaymentDistribs = [];
      ledgerItemClone.dataARTransactionItem = null;
      ledgerItemClone.xauditCreateByUser = null;
      await this.arService.saveLedgerItem(ledgerItemClone).toPromise();
    } catch (err) {
      console.error('Error in ArLedgerComponent saveDetailForLedger', err);
    }
  }

  setDateRangeValues(start, end) {
    this.dRangeStart = new Date(start);
    this.dRangeEnd = new Date(end);

    this.globals.ledgerActiveFilterDateRangeStart = start;
    this.globals.ledgerActiveFilterDateRangeEnd = end;
  }

  returnDateOnly(d: Date) {
    d = new Date(d.toDateString());
    return d;
  }

  closeOtherFilterDropdowns(except: string) {
    if (except !== 'doctor') this.doctorSelect?.close();
    if (except !== 'date') this.picker?.close();
    if (except !== 'location') this.locationSelect?.close();
    if (except !== 'tooth') this.toothSelect?.close();
    if (except !== 'code') this.codeSelect?.close();
  }

  filterLedgerItemsByDateRange(apply: boolean = true) {
    if (this.activeFilterDateRangeOn) {
      if (!this.dRangeStart || !this.dRangeEnd) {
        this.activeFilterOrganizer.filterLedgerItemsByDateRange = (item) => true;
      } else {
        this.activeFilterOrganizer.filterLedgerItemsByDateRange = (item) => {
          if (!item.PostDate) {
            return false;
          }
          return this.returnDateOnly(new Date(item.PostDate)) >= this.returnDateOnly(new Date(this.dRangeStart)) && this.returnDateOnly(new Date(item.PostDate)) <= this.returnDateOnly(new Date(this.dRangeEnd));
        };
      }
    }
    else {
      this.activeFilterOrganizer.filterLedgerItemsByDateRange = (item) => true;
      this.dRangeStart = null;
      this.dRangeEnd = null;
      this.dateRangeStart.nativeElement.value = '';
      this.dateRangeEnd.nativeElement.value = '';
      this.dateRangeInput.value.end = '';
      this.dateRangeInput.value.start = '';
    }

    if (apply) {
      this.globals.ledgerActiveFilterDateRangeOn = this.activeFilterDateRangeOn ? '1' : '0';
      this.applyFilters();
    }
  }

  filterLedgerItemsByCode(apply: boolean = true) {
    if (this.activeFilterCodeOn) {
      const selectedCodes = this.codes.value;

      if (selectedCodes.length === 0) {
        this.activeFilterOrganizer.filterLedgerItemsByCode = (item) => true;
      } else {
        this.activeFilterOrganizer.filterLedgerItemsByCode = (item) => {
          if (!item.dataARTransactionItemList) {
            return false;
          }
          let exists: boolean = false;
          selectedCodes.forEach(a => {
            if (a === item.dataARTransactionItemList.Code) {
              exists = true;
            }
          });
          return exists;
        };
      }
    }
    else {
      this.activeFilterOrganizer.filterLedgerItemsByCode = (item) => true;
      this.codes.setValue([]);
    }

    if (apply) {
      // save
      this.globals.ledgerActiveFilterCodeOn = this.activeFilterCodeOn ? '1' : '0';
      this.globals.ledgerActiveFilterCodes = this.codes.value;
      this.activeFilterCodesSelected = this.globals.ledgerActiveFilterCodes;
      this.applyFilters();
    }
  }

  filterLedgerItemsByTooth(apply: boolean = true) {
    if (this.activeFilterToothOn) {
      const selectedTeeth = this.teeth.value;

      if (selectedTeeth.length === 0) {
        this.activeFilterOrganizer.filterLedgerItemsByTooth = (item) => true;
      } else {
        this.activeFilterOrganizer.filterLedgerItemsByTooth = (item) => {
          if (!item.dataARTransactionItemList) {
            return false;
          }
          let exists: boolean = false;
          selectedTeeth.forEach(a => {
            if (a === item.dataARTransactionItemList.TeethReference) {
              exists = true;
            }
          });
          return exists;
        };
      }
    }
    else {
      this.activeFilterOrganizer.filterLedgerItemsByTooth = (item) => true;
      this.teeth.setValue([]);
    }

    if (apply) {
      // save
      this.globals.ledgerActiveFilterToothOn = this.activeFilterToothOn ? '1' : '0';
      this.globals.ledgerActiveFilterTeeth = this.teeth.value;
      this.activeFilterTeethSelected = this.globals.ledgerActiveFilterTeeth;  
      this.applyFilters();
    }
  }

  filterLedgerItemsByDoctor(apply: boolean = true) {
    if (this.activeFilterDoctorOn) {
      if (this.activeFilterDoctorId === 'All Doctors') {
        this.activeFilterOrganizer.filterLedgerItemsByDoctor = (item) => true;
      } else {
        this.activeFilterOrganizer.filterLedgerItemsByDoctor = (item) => {
          if (!item.dataARTransactionItemList) {
            return false;
          }
          return item.DoctorName === this.activeFilterDoctorId;
        };
      }
    }
    else {
      this.activeFilterOrganizer.filterLedgerItemsByDoctor = (item) => true;
      this.activeFilterDoctorId = 'All Doctors';
    }

    if (apply) {
      // save
      this.globals.ledgerActiveFilterDoctorId = this.activeFilterDoctorId;
      this.globals.ledgerActiveFilterDoctorOn = this.activeFilterDoctorOn ? '1' : '0';
      this.applyFilters();
    }
  }

  filterLedgerItemsByLocation(apply: boolean = true) {
    if (this.activeFilterLocationOn) {
      if (this.activeFilterLocationId === 'All Locations') {
        this.activeFilterOrganizer.filterLedgerItemsByLocation = (item) => true;
      } else {
        this.activeFilterOrganizer.filterLedgerItemsByLocation = (item) => {
          if (!item) {
            return false;
          }
          let exists: boolean = false;
          if (item.dataARTransactionItemList && item.dataARTransactionItemList.LOCID == this.activeFilterLocationId) {
            exists = true;
          }
          if (item.LOCID && item.LOCID == this.activeFilterLocationId) {
            exists = true;
          }
          return exists;
        };
      }
    }
    else {
      this.activeFilterOrganizer.filterLedgerItemsByLocation = (item) => true;
      this.activeFilterLocationId = 'All Locations';
    }

    if (apply) {
      // save
      this.globals.ledgerActiveFilterLocationId = this.activeFilterLocationId;
      this.globals.ledgerActiveFilterLocationOn = this.activeFilterLocationOn ? '1' : '0';
      this.applyFilters();
    }
  }

  filterOutItemsByPaidStatus(payload) {
    if (payload) {
      this.activeFilterOrganizer.filterOutItemsByPaidStatus = (item) => {
        return LEDGER_ITEM_STATUS.Paid !== item.enumLedgerItemStatusID;
      };
    } else {
      this.activeFilterOrganizer.filterOutItemsByPaidStatus = (item) => true;
    }
    this.applyFilters();
  }

  filterOutItemsByVoided(payload, apply: boolean = true) {
    if (payload) {
      this.activeFilterOrganizer.filterOutItemsByVoided = (item) => {
        return LEDGER_ITEM_STATUS.Void !== item.enumLedgerItemStatusID;
      };
    } else {
      this.activeFilterOrganizer.filterOutItemsByVoided = (item) => true;
    }

    if (apply) {
      // save
      this.hideVoidedLedgerItems = payload;
      this.globals.ledgerActiveFilterVoidOn = this.hideVoidedLedgerItems ? '1' : '0';
      this.applyFilters();
    }

  }

  filterOutItemsByPaymentPlanItems(payload) {
    if (payload) {
      this.activeFilterOrganizer.filterOutItemsByPaymentPlanItems = (item: DataARLedgerListModel) => {
        return !item.DATA_IS_IN_PLAN;
      };
    } else {
      this.activeFilterOrganizer.filterOutItemsByPaymentPlanItems = (item) => true;
    }
    this.applyFilters();
  }

  applyFilters(saveFilter: boolean = true) {
    this.saveFilterToString();

    // first, save filter params to db
    if (saveFilter) {
      this.saveFilterParamsToDB();
    }

    this.activeFilterLedgerItemFunctions = [];

    for (const i in this.activeFilterOrganizer) {
      this.activeFilterLedgerItemFunctions.push(this.activeFilterOrganizer[i]);
    }
  }

  generateLocationList() {
    this.locationList = [];
    this.dataLedgerItems.forEach(ledgerItem => {
      const location = new SelectTDOCIDLOCIDModel();
      if (ledgerItem.LOCID) {
        location.LOCID = ledgerItem.LOCID;
        location.LocationName = ledgerItem.LocationName;
        location.ClientName = ledgerItem.ClientName;

        const locationIsAdded = this.locationList.findIndex(a => {
          return a.LOCID === ledgerItem.LOCID;
        }) > -1;

        if (!locationIsAdded) {
          this.locationList.push(location);
        }
      }
    });
  }

  generateDoctorList() {
    this.doctorList = [];
    this.dataLedgerItems.forEach(ledgerItem => {
      if (ledgerItem.DoctorName) {
        const doctorIsAdded = this.doctorList.findIndex(doc => {
          return doc === ledgerItem.DoctorName;
        }) > -1;
        if (!doctorIsAdded) {
          this.doctorList.push(ledgerItem.DoctorName);
        }
      }
    });
  }

  generateCodeList() {
    this.codeList = [];
    this.dataLedgerItems.forEach(ledgerItem => {
      const hasCode = ledgerItem.dataARTransactionItemList && ledgerItem.dataARTransactionItemList.Code;
      if (hasCode) {
        const codeIsAdded = this.codeList.findIndex(code => {
          return code === ledgerItem.dataARTransactionItemList.Code;
        }) > -1;
        if (!codeIsAdded) {
          this.codeList.push(ledgerItem.dataARTransactionItemList.Code);
        }
      }
    });
  }

  generateToothList() {
    this.toothList = [];
    this.dataLedgerItems.forEach(ledgerItem => {
      const hasTooth = ledgerItem.dataARTransactionItemList && ledgerItem.dataARTransactionItemList.TeethReference;
      if (hasTooth) {
        const toothIsAdded = this.toothList.findIndex(tooth => {
          return tooth === ledgerItem.dataARTransactionItemList.TeethReference;
        }) > -1;
        if (!toothIsAdded) {
          this.toothList.push(ledgerItem.dataARTransactionItemList.TeethReference);
        }
      }
    });
  }

  getPaymentPlansForPatient(PatientId: string): Promise<DataARPaymentPlanModel[]> {
    return this.arService.getPaymentPlansForPatient(PatientId).toPromise();
  }

  getCreditsForLedger(PatientId: string): Promise<DataArLedgerCredits> {
    return this.arService.getCreditsForLedger(PatientId).toPromise();
  }

  getDoctorsByPatientLedger(PatientId: string): Promise<DoctorByTDOCIDModel[]> {
    return this.arService.getDoctorsByPatientLedger(PatientId).toPromise();
  }

  returnSalutation(enumValue: string) {

    enumValue = enumValue.toUpperCase();
    if (enumValue === SalutationEnum.Dr) {
      return 'Dr. ';
    }
    else if (enumValue === SalutationEnum.Prof) {
      return 'Prof. ';
    }
    else if (enumValue === SalutationEnum.Mr) {
      return 'Mr. ';
    }
    else {
      return '';
    }
  }

  // sortRadioChange(event: MatRadioChange, toSort: string) {
  //   this.activeSortDirection = event.value;
  //   this.sortLedgerItems(this.dataLedgerItems, toSort);
  // }

  filterSelectChange(event: MatSelectChange, toFilter: string) {
    this.dataLedgerItems = this.bkDataLedgerItems;
    if (event.value !== 'default') {
      this.dataLedgerItems = this.dataLedgerItems.filter(item => {
        if (item.dataARTransactionItem && item.dataARTransactionItem.ProviderDoctorId) {
          if (item.dataARTransactionItem.ProviderDoctorId === event.value) {
            return item;
          }
        }
      });
    }
  }

  async printLedger(ReportId: string) {
    if (this.printingReportId) return;
    this.printingReportId = ReportId;
    const ledgerPrintParameters = new PrintLedgerParamsModel();
    ledgerPrintParameters.EnterpriseID = localStorage.getItem('TDOEnterpriseId');
    ledgerPrintParameters.LOCID = this.LOCID;
    ledgerPrintParameters.PatientID = this.PatientId;
    ledgerPrintParameters.ReportId = ReportId
    ledgerPrintParameters.isHideVoided = this.hideVoidedLedgerItems;
    ledgerPrintParameters.UserId = this.localStorageService.currentUserData.authdata.userid;
    try {
      let documentID = await this.printService.printReport(ReportId, ledgerPrintParameters).toPromise();
      this.printService.executePrint([documentID]);
    }
    catch (error) {
      this.createMessage('Error when trying to print Document.', 'error');
    }
    finally {
      this.printingReportId = null;
    }
  }


  // Handle selection and deselection of rows model data
  onLedgerItemRowSelectedClick(row): void {
    this.clickTimer = setTimeout((ledgerId) => {
      if (this.selectedRowLedgerId != ledgerId)
        this.selectedRowLedgerId = ledgerId;
      else
        this.selectedRowLedgerId = '';
      const model = new TdoNoteQueryModel();
      model.parentObjectName = 'dataARLedger';
      model.objectId = this.selectedRowLedgerId;
      model.patientId = this.globals.currentPatientId;
      model.categoryEnumId = NoteCategoryEnum.Ledger;
      model.typeEnumId = NoteTypeEnum.Patient;
      this.notesService.changeNoteQuery(model);
      this.safeDetectChanges();
    }, 200, row.LedgerID);
  }
  onLedgerItemRowSelectedDoubleClick(row): void {
    clearTimeout(this.clickTimer);
    this.clickTimer = undefined;
    this.onLedgerItemRowSelected(row);
  }

  onLedgerItemRowSelected(row) {

    const ledgerModel = this.dataLedgerItems.find(p => p === row);

    if (ledgerModel.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.ClaimCreated) {
      // open claim window
      this.openClaimByClaimID(ledgerModel.ARLedgerItemTypeReferenceObjectID);
    }
    else if (ledgerModel.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditPayment) {
      // open payment details
      this.openPaymentDetailsWindow(ledgerModel);
    }
    else if (ledgerModel.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit 
      && ledgerModel.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypePatient) {
      // open ledger item detail window
      this.openLedgerItemDetailsWindow(ledgerModel);
    }
    else if (ledgerModel.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Refund
      || ledgerModel.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Surcharge
      || ledgerModel.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.SurchargePayment) {
      // open payment details for refund or credit card surcharge
      this.openPaymentDetailsWindow(ledgerModel);
    }
  }

  openClaimWizard(claimType: string) {

    // 'real' getting passed from UI
    let claimEnumType = '';
    if (claimType === 'pre') {
      claimEnumType = ClaimTypeEnum.Predetermination;
    }
    else if (claimType === 'real') {
      claimEnumType = ClaimTypeEnum.RealClaim;
    }

    let blError: boolean = false;
    let ledgerItemsToClaim: DataARLedgerListModel[] = [];
    this.dataLedgerItems.forEach(item => {
      //if (item.DATA_SELECTED) {

      // if ledger item is a parent, need to copy the data
      if (item.isParentTransaction) {
        const children = this.dataLedgerItems.filter(a => a.ARTransactionItemID === item.ARTransactionItemID && !a.isParentTransaction);
        if (children.length > 0) {
          item.dataARTransactionItemList = children[0].dataARTransactionItemList;
        }
      }

      // push ledger item
      ledgerItemsToClaim.push(item);
      //}
    });

    if (ledgerItemsToClaim.length === 0) {
      ledgerItemsToClaim = this.dataLedgerItems;
    }

    if (ledgerItemsToClaim.length > 0) {
      // only open dialog if transactions were selected
      const dialogRef = this.dialog.open(ClaimWizardComponent, {
        width: '1500px',
        height: '800px',
        data: {
          PatientId: this.PatientId,
          dataLedgerItems: ledgerItemsToClaim,
          selectedClaimType: claimEnumType
        },
        panelClass: 'dialog'
      });
      const claimWizardSub = dialogRef.afterClosed().subscribe(async result => {
        try {
          if (result) {
            await this.init();
            this.initTableLayout();
          }
        } catch (err) {
          console.error('Error in claim wizard dialog:', err);
        }
      });
      this.subscriptions.push(claimWizardSub);
    }
  }

  createNoteForLedgerItem(todo: string, data: any) {
    if (todo === 'add') {

      // add note for ledger item
      const model = new TdoNoteSaveModel();
      model.patientId = this.globals.currentPatientId;
      //model.dataNote.isLocked = false;

      const associatedObjects = [];
      const newAssociatedObjectCase = new TdoNoteAssociatedObject();
      newAssociatedObjectCase.objectId = this.globals.currentPatientCaseId;
      newAssociatedObjectCase.parentObjectName = 'dataPatientCase';
      associatedObjects.push(newAssociatedObjectCase);

      const newAssociatedObjectLedgerItem = new TdoNoteAssociatedObject();
      newAssociatedObjectLedgerItem.objectId = data;
      newAssociatedObjectLedgerItem.parentObjectName = 'dataARLedger';
      associatedObjects.push(newAssociatedObjectLedgerItem);

      model.associatedObjects = associatedObjects;
      model.categoryEnumIds.push(NoteCategoryEnum.Ledger);
      model.typeEnumIds.push(NoteTypeEnum.Patient);

      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_CREATE_NOTE, model);

      data.NoteCount += 1;
      // update note count locally
      // this.dataLedgerItems.every(a => {
      //   if (a.LedgerID === data.LedgerID) {
      //     a.NoteCount += 1;
      //     return false;
      //   }
      //   return true;
      // });
    }

  }

  resetNotesFilter() {
    const model = new TdoNoteQueryModel();
    model.parentObjectName = 'dataARLedger';
    model.objectId = '';
    model.patientId = this.globals.currentPatientId;
    model.categoryEnumId = NoteCategoryEnum.Ledger;
    model.typeEnumId = NoteTypeEnum.Patient;
    this.notesService.changeNoteQuery(model);

  }


  onLedgerItemContext(event: MouseEvent, item: DataARLedgerListModel) {
    this.openContext(event, this.ledgerItemContextTemplate, item);
  }

  // Context boilerplate
  openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
    this.closeContext();
    x = x + 100;
    y = y - 10;
    const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }
    ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          if (closeOnItemClick) {
            this.closeContext();
          } else {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }
        }), take(1)).subscribe(() => this.closeContext());
  }

  closeContext(): void {
    this.sub !== undefined && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  // onRowContextMenu(event: TdoTableSelectionEvent) {
  //   this.openContext(event.mouseEvent, this.ledgerItemContextTemplate, event.model);
  // }

  onRowContextMenu(event: MouseEvent, row: DataARLedgerListModel) {
    this.openContext(event, this.ledgerItemContextTemplate, row);
  }

  isCanEditPatientPayment() {
    return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.PaymentFromPatient);
  }

  async checkPaymentReversal(data: any) {
    {
      const dialogRef = this.dialog.open(CreateAdjustment2Component, {
        panelClass: 'dialog',
        autoFocus: false,
        data: {
          type: 'checkreversal',
          PatientId: this.PatientId,
          dataLedgerItems: this.dataLedgerItems,
          paymentLedgerItemToVoid: data
        }
      });
      const adjustSub = dialogRef.afterClosed().subscribe(async result => {
        try {
          if (result) {
            await this.init();
            this.initTableLayout();
          }
        } catch (err) {
          console.error('Error in check reversal dialog:', err);
        }
      });
      this.subscriptions.push(adjustSub);
    }
  }

  async voidPayment(data: any) {

    // open payment refund confirmation dialog
    const dialogRef = this.dialog.open(ArPaymentRefundConfirmComponent, {
      panelClass: 'dialog',
      data: {
        PaymentID: data.PaymetnID
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    }, err => {
    });
  }

  async voidPayment2(data: any) {

    // open payment refund confirmation dialog
    const dialogRef = this.dialog.open(ArPaymentCancelComponent, {
      panelClass: 'dialog',
      data: {
        PaymentID: data.PaymetnID
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    }, err => {
    });
  }

  voidChargeItems(item: any, itemsToUpdate: DataARLedgerListModel[]) {
    const dialogRef = this.dialog.open(ArLedgerChargeVoidComponent, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        PatientId: this.PatientId,
        paymentLedgerItemToVoid: item
      }
    });
    const chargeVoidWindowSub = dialogRef.afterClosed().subscribe(async result => {
      if (result !== null && result !== undefined)  {
        itemsToUpdate.forEach(a => {
          a.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Void;
          a.explanationForVoid = result;
        });
        // save ledger status change
            this.arService.updateLedgerItem(itemsToUpdate, true).subscribe(saved => {
              if (saved) {
                // save successful
                this.createMessage('Item(s) updated', 'Success');

                // reload ledger
                this.reloadLedger();
              }
            }, err => {
              this.createMessage(`Error saving ledger item: ${err.ExceptionMessage??err.Message}`, 'Error');
              this.reloadLedger();
            });
            //this.subscriptions.push(ledgerUpdateSub);
      }
      else{
        console.log('voidClaimCharge ArLedgerChargeVoidComponent result NO UPDATE');

      }
    }, err => {
    });
    //this.subscriptions.push(chargeVoidWindowSub);

  }

  voidCharge(data: any) {
    // console.log('voidCharge OLD', data);
    // if (data.ARClaimID && data.enumClaimCheckStatusID !== ClaimStatusEnum.Canceled){
    //   this.createMessage(`This transaction cannot be voided because there is an active claim associated with it (${data.Reference}).`, 'Error');
    //   return;      
    // }
    if (data.PaymentsTotal === 0) {
      let itemsToUpdate: DataARLedgerListModel[] = [];
        // explanation is required
          if (data.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.WriteOff) {

            // open dialog first, then call backend to void writeoff and switch to patient pay
            const dialogRef = this.dialog.open(ArLedgerChargeVoidComponent, {
              panelClass: 'dialog',
              autoFocus: false,
              data: {
                PatientId: this.PatientId,
                paymentLedgerItemToVoid: data
              }
            });
            dialogRef.afterClosed().subscribe(async result => {
              if (result !== null && result !== undefined) {
                const note = new NoteDataModel();
                note.Note = result;
                this.arService.voidWriteOff(data.LedgerID, note).subscribe(async saved => {
                  if (saved) {
                    // save successful
                    this.createMessage('Item(s) updated', 'Success');

                    // reload ledger
                    await this.reloadLedger();
                  }
                }, err => {
                  this.createMessage('Error saving ledger item', 'Error');
                });
              }
            });
            return; // prevent fall-through to voidChargeItems with empty itemsToUpdate
          }
          else if (data.isParentTransaction) {
            // debit with related items
            // const children = this.dataLedgerItems.filter(a => a.ParentLedgerID === data.LedgerID);
            const children = this.dataLedgerItems.filter(a => a.ARTransactionItemID === data.ARTransactionItemID);
            children.forEach(a => {
              //a.enumLedgerItemStatusID = this.enumLedgerItemStatusVoid;
              itemsToUpdate.push(a);
            });
          }
          else {
            // single debit
            //data.enumLedgerItemStatusID = this.enumLedgerItemStatusVoid;
            itemsToUpdate.push(data);
          }
            this.voidChargeItems(data, itemsToUpdate);
        
    }
    else {
      this.createMessage('This transaction cannot be voided because there are payments associated with it.', 'Error');
    }
  }

  async viewPayment(data: any) {

    // load payment window
    this.openPaymentDetailsWindow(data);

  }

  async refundAnyAmount() {

    // open payment refund confirmation dialog
    const dialogRef = this.dialog.open(ArPaymentRefundAnyAmountConfirmComponent, {
      panelClass: 'dialog',
      data: {
        Amount: 0
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    }, err => {
    });
  }

  getPayment(PaymentID: string) {
    return this.arService.getPayment(PaymentID).toPromise();
  }

  datediff(first, second) {
    // Take the difference between the dates and divide by milliseconds per day.
    // Round to nearest whole number to deal with DST.
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
  }


  isTransRow(enumARLedgerItemOriginTypeID: string) {
    if (enumARLedgerItemOriginTypeID != null && enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypeTransaction) {
      return true;
    }
    else {
      return false;
    }
  }

  isChildRow(ledgerRow: DataARLedgerListModel) {
    if (!this.isTransRow(ledgerRow.enumARLedgerItemOriginTypeID)) {
      // not a trans row
      if (ledgerRow.ARTransactionItemID && ledgerRow.ParentLedgerID && ledgerRow.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit) {
        return true;
      }
    }
    return false;
  }

  isActive(enumLedgerItemStatusID: string) {
    if (enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void) {
      return true;
    }
    else {
      return false;
    }
  }

  openClaimByClaimID(claimId: string) {
    const config = new MatDialogConfig();
    config.width = '900px';
    config.height = '700px';
    config.data = {
      ARClaimID: claimId,
    };
    config.panelClass = 'dialog';

    const modal = this.dialog.open(ClaimViewComponent, config);

    const claimIdSub = modal.afterClosed().subscribe(result => {
      if (result) {
        this.init(false);
      }
    }, err => {
    });
    this.subscriptions.push(claimIdSub);
  }

  showPaymentDistributions(LedgerID: string) {

    const config = new MatDialogConfig();
    config.width = '800px';
    config.height = '450px';
    config.data = {
      LedgerID,
    };
    config.panelClass = 'dialog';

    const modal = this.dialog.open(ArLedgerPaymentDistributionsComponent, config);
  }

  openLedgerItemDetailsWindow(item: DataARLedgerListModel) {
    const dialogRef = this.dialog.open(ArLedgerProcedureDetailsComponent, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        dataLedgerItem: item,
        dataLedgerItems: this.dataLedgerItems.filter(a => a.dataARTransactionItemList.ARTransactionItemID === item.dataARTransactionItemList.ARTransactionItemID),
        allDataLedgerItems: this.dataLedgerItems
      }
    });
    const ledgerDetailsSub = dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        await this.init();
        this.initTableLayout();
      }
    }, err => {
    });
    this.subscriptions.push(ledgerDetailsSub);
  }

  openPaymentDetailsWindow(item: DataARLedgerListModel) {
    const dialogRef = this.dialog.open(ArPaymentDetailsComponent, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        PaymentID: item.PaymetnID,
        ledgerItem: item,
        patientId: this.PatientId
      }
    });
    const paymentDetailsSub = dialogRef.afterClosed().subscribe(result => {

    }, err => {
    });
    this.subscriptions.push(paymentDetailsSub);
  }

  openPaymentDistributionDetailsWindow(item: DataARLedgerListModel) {
    const dialogRef = this.dialog.open(ArPaymentDistributionsComponent, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        PaymentID: item.PaymetnID,
        ledgerItem: item,
        patientId: this.PatientId
      }
    });
    const paymentDetailsSub = dialogRef.afterClosed().subscribe(result => {

    }, err => {
    });
    this.subscriptions.push(paymentDetailsSub);
  }

  returnRowColor(item: DataARLedgerListModel) {
    let className = '';
    if (item.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Void) {
      className = 'row-color-void';
    }
    return className;
  }

  async saveDataPatientProperties()  {
    // save selections
    const dp = new PatientDataModel();
    dp.PatientId = this.PatientId;
    dp.isChargeInterest = this.isInterest;
    dp.isOnPaymentPlan = this.isPaymentPlan;
    dp.isSentCollection = this.isCollections;
    try {
    const saved = await firstValueFrom(this.arService.saveDataPatientProperties(dp));
      if (saved) {
        // save successful
        this.createMessage('Updated', 'Success');        
        this.presavedIsSentCollection = this.isCollections;
        this.presavedIsOnPaymentPlan = this.isPaymentPlan;
        this.presavedIsChargeInterest = this.isInterest;
      }
      else {
      this.createMessage('Error saving items', 'Error');
      this.revertDataPatientProperties();
    }    
    }
    catch (error) {
      console.error('Error in ArLedgerComponent saveDataPatientProperties', error);
      this.createMessage('Error saving items', 'Error');
      this.revertDataPatientProperties();
    }
  }
  revertDataPatientProperties() {
    this.isCollections = this.presavedIsSentCollection;
    this.isPaymentPlan = this.presavedIsOnPaymentPlan;
    this.isInterest = this.presavedIsChargeInterest;
    this.safeDetectChanges();
  }

  async interestClicked(event: any): Promise<void> {
    this.dialogService.openConfirmDialog(`Are you sure you want to change Interest?`).subscribe((result) => {
      if (result === true) {
        this.isInterest = event;
        this.saveDataPatientProperties();
      }
      else {
        //if cancel, revert to original value
        this.isInterest = !this.isInterest;
      }
    });
  }

  async collectionsClicked(event: any): Promise<void> {

    this.dialogService.openConfirmDialog(`Are you sure you want to change Collections?`).subscribe((result) => {
      if (result === true) {
        this.isCollections = event;        
        this.saveDataPatientProperties();
      }
      else {
        //if cancel, revert to original value
        this.isCollections = !this.isCollections;
      }
    });
  }

  async paymentPlanClicked(event: any): Promise<void> {
    this.dialogService.openConfirmDialog(`Are you sure you want to change Payment Plan?`).subscribe((result) => {
      if (result === true) {
        this.isPaymentPlan = event;
        this.saveDataPatientProperties();
      }
      else {
        //if cancel, revert to original value
        this.isPaymentPlan = !this.isPaymentPlan;
      }
    });
  }


  openAdjustmentWindowToVoidPayment( paymentLedgerItem: DataARLedgerListModel) {
    const dialogRef = this.dialog.open(CreateAdjustment2Component, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        type: 'void-payment',
        PatientId: this.PatientId,
        dataLedgerItems: this.dataLedgerItems,
        paymentLedgerItemToVoid: paymentLedgerItem
      }
    });
    const adjustmentWindowSub = dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        await this.init();
        this.initTableLayout();
      }
    }, err => {
    });
    this.subscriptions.push(adjustmentWindowSub);
  }


  // paymentTransactionVoidClicked(item: DataARLedgerListModel) {
  //   this.openAdjustmentWindowToVoidPayment('void-payment', item);
  // }

  saveFilterParamsToDB() {
    const userId = this.localStorageService.currentUserData.authdata.userid;
    this.arService.saveUserParams(this.activeFilterDBString, userId, this.ledgerFilterParamsName).subscribe(saved => {
      if (saved) {
        // save successful
        this.createMessage('Filter settings saved', 'Success');
      }
    }, err => {
      this.createMessage('Error saving filter settings', 'Error');
    });
  }

  activeFilterOn() {
    if (this.activeFilterCodeOn || this.activeFilterToothOn || this.activeFilterDoctorOn || this.activeFilterLocationOn || this.activeFilterDateRangeOn) {
      return this.activeFilter = true;
    }
    else { this.activeFilter = false }
  }

  columnsFilterOn() {
    let columnFilterOn = false;
    this.displayedTableLayout.filter(f => f.isGroupColumn).forEach(a => {
      if (a.showColumn === false) { columnFilterOn = true; }
      a.childColumns.forEach(aa => {
        if (aa.showColumn === false) { columnFilterOn = true; }
      });
    });
    return columnFilterOn;
  }

  writeOffCharge(data: any) {
    if (data.PaymentsTotal === 0) {
      let itemsToUpdate: DataARLedgerListModel[] = [];
      this.dialogService.openConfirmDialog(`Are you sure you want to write off this transaction?`).subscribe((result) => {
        if (result === true) {
          // single debit
          data.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.WriteOff;
          data.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Void;
          itemsToUpdate.push(data);

          // save ledger status change
          this.arService.updateLedgerItem(itemsToUpdate).subscribe(saved => {
            if (saved) {
              // save successful
              this.createMessage('Item(s) updated', 'Success');

              // ledger
              this.reloadLedger();
            }
          }, err => {
            this.createMessage('Error saving ledger item', 'Error');
          });
        }
      });
    }
    else {
      this.createMessage('This transaction cannot be written off because there are payments associated with it.', 'Error');
    }
  }

  async reloadLedger() {
    this.isLoading = true;
    try {
      await this.init(false);
    } catch (err) {
      console.error('Error in ArLedgerComponent reloadLedger', err);
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
    }
  }

  claimRefused(ledgerItem: DataARLedgerListModel) {
    const dialogRef = this.dialog.open(ArInsurancePaymentComponent, {
      width: '90%',
      panelClass: 'dialog',
      data: {
        type: 'insurance-claim-refusal',
        PatientId: this.PatientId,
        LedgerItem: ledgerItem,
      }
    });
    const claimRefuseSub = dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        await this.init();
        this.initTableLayout();
      }
    }, err => {
    });
    this.subscriptions.push(claimRefuseSub);
  }

  claimCanBeRefused(ledgerItem: DataARLedgerListModel) {
    if (!ledgerItem.enumClaimStatusID) {
      return false;
    }
    else if (ledgerItem.enumClaimStatusID === ClaimStatusEnum.Canceled || ledgerItem.enumClaimStatusID === ClaimStatusEnum.Closed) {
      return false;
    }
    else {
      return true;
    }
  }

  async checkForEOBDocuments() {
    // Only check for insurance payment ledger items
    const insurancePayments = this.dataLedgerItemsTable.filter(item => 
      item.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditPayment && 
      item.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypeInsurance
    );

    for (const payment of insurancePayments) {
      try {
        const eobDocuments = await firstValueFrom(this.fileManagerService.getEOBDocuments(this.PatientId, payment.PaymetnID));
        if (eobDocuments && eobDocuments.length > 0) {
          payment.HasEOBDocument = true;
          // Extract document IDs from the EOB documents
          payment.EOBDocumentIds = eobDocuments.map(doc => doc.DocumentID);
          this.safeDetectChanges();
        }
      } catch (err) {
        console.error('Error checking for EOB documents for PaymentID:', payment.PaymetnID, err);
      }
    }
  }

  async openEOBDocument(ledgerItem: DataARLedgerListModel, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    
    if (!ledgerItem.HasEOBDocument || !ledgerItem.EOBDocumentIds || ledgerItem.EOBDocumentIds.length === 0) {
      this.createMessage('No EOB document found for this payment', 'Warning');
      return;
    }

    // Verify documents exist before opening viewer
    try {
      const documents = await firstValueFrom(this.fileManagerService.getDocuments(ledgerItem.EOBDocumentIds));
      if (!documents || documents.length === 0) {
        this.createMessage('Unable to load EOB document', 'Error');
        console.error('No documents returned for IDs:', ledgerItem.EOBDocumentIds);
        return;
      }
      const config = new MatDialogConfig();
      config.panelClass = 'standard-dialog';
      config.data = ledgerItem.EOBDocumentIds;
      config.maxWidth = '100dvw';
      config.maxHeight = '100dvh';
      config.width = '98%';
      config.height = '98%';
      config.autoFocus = false; 
      
      this.dialog.open(TdoOrganizerSlideshowDialogComponent, config).afterClosed().subscribe((res) => {
        
      });
    } catch (err) {
      console.error('Error loading EOB documents:', err);
      this.createMessage('Error loading EOB document', 'Error');
    }
  }

  onEOBIconRightClick(ledgerItem: DataARLedgerListModel, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    
    this.selectedEOBLedgerItem = ledgerItem;
    this.eobMenuPositionX = event.clientX + 'px';
    this.eobMenuPositionY = event.clientY + 'px';
    
    if (this.eobDocumentMenuTrigger) {
      this.eobDocumentMenuTrigger.openMenu();
    }
  }

  async deleteEOBDocument() {
    if (!this.selectedEOBLedgerItem?.EOBDocumentIds || this.selectedEOBLedgerItem.EOBDocumentIds.length === 0) {
      this.createMessage('No EOB document to delete', 'Warning');
      return;
    }

    // Confirm before deleting
    this.dialogService.openConfirmDialog(
      `Are you sure you want to delete the EOB document${this.selectedEOBLedgerItem.EOBDocumentIds.length > 1 ? 's' : ''}?`
    ).subscribe(async (confirmed) => {
      if (confirmed) {
        try {
          // Delete all EOB documents for this payment
          for (const documentId of this.selectedEOBLedgerItem.EOBDocumentIds) {
            await firstValueFrom(this.fileManagerService.markDocumentAsDeleted(documentId));
          }
          
          // Clear the EOB document flags on the ledger item
          this.selectedEOBLedgerItem.HasEOBDocument = false;
          this.selectedEOBLedgerItem.EOBDocumentIds = [];
          
          this.createMessage('EOB document deleted successfully', 'Success');
        } catch (err) {
          console.error('Error deleting EOB document:', err);
          this.createMessage('Error deleting EOB document', 'Error');
        }
      }
      this.selectedEOBLedgerItem = null;
    });
  }

  private safeDetectChanges() {
    const viewRef = this.cdr as any;
    if (!viewRef.destroyed) {
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    if (this.clickTimer) {
      clearTimeout(this.clickTimer);
      this.clickTimer = undefined;
    }
    for (const sub of this.subscriptions) {
      if (sub)
        sub.unsubscribe();
    }
  }
}
